export default {
  school: "University of Nevada, Las Vegas",
  degrees: "Bachelor of Arts in Mathematics, Bachelor of Arts in Economics",
};
